import {
  category_cards,
  control_category_options,
  control_frequency_options,
  control_result_options,
  create_empty_control_form,
  register_cards,
  register_chips,
  register_rows,
  remediation_cards,
  remediation_rows,
  tabs,
  testing_cards,
  testing_rows
} from './controls_data';
import { drawer_computed } from './controls_drawer';
import { controls_hooks, controls_methods, controls_watch } from './controls_helper';

export default {
  name: 'ComplyonControlsLibrary',
  data: () => ({
    active_tab: 'register',
    tabs,
    register_cards,
    register_chips,
    register_rows,
    category_cards,
    testing_cards,
    testing_rows,
    remediation_cards,
    remediation_rows,
    control_category_options,
    control_frequency_options,
    control_result_options,
    control_modal_open: false,
    control_modal_mode: 'create',
    control_modal_index: null,
    control_modal_form: create_empty_control_form(),
    active_control_drawer_key: null,
    active_remediation_drawer_key: null
  }),
  computed: {
    ...drawer_computed
  },
  methods: {
    ...controls_methods
  },
  mounted: controls_hooks.mounted,
  beforeDestroy: controls_hooks.beforeDestroy,
  watch: controls_watch
};
